import { apiClient } from "./apiClient";

const auth = (accessToken) => ({ headers: { Authorization: `Bearer ${accessToken}` } });

export const getTenantLicenses = (accessToken, tenantId) =>
  apiClient.get(`/admin/licenses/tenants/${tenantId}`, auth(accessToken)).then((res) => res.data);

export const getExpiringLicenses = (accessToken) =>
  apiClient.get("/admin/licenses/expiring", auth(accessToken)).then((res) => res.data);

export const updateTenantLicenses = (accessToken, tenantId, payload) =>
  apiClient.patch(`/admin/licenses/tenants/${tenantId}`, payload, auth(accessToken)).then((res) => res.data);

export const updateEdgeLicense = (accessToken, edgeId, payload) =>
  apiClient.patch(`/admin/licenses/edges/${edgeId}`, payload, auth(accessToken)).then((res) => res.data);
